import { createContext, useContext } from 'react';

export interface RondoNav {
  openUserDetail: (id: number) => void;
  closeUserDetail: () => void;
}

const RondoNavContext = createContext<RondoNav | null>(null);

export const RondoNavProvider = RondoNavContext.Provider;

export function useRondoNav(): RondoNav {
  const v = useContext(RondoNavContext);
  if (!v) throw new Error('useRondoNav must be used within RondoNavProvider');
  return v;
}
